module.exports = __webpack_public_path__ + "img/up.cd204a5f.png";